export default __webpack_public_path__ + "static/media/galarie6.6e624dee.jpg";